import React from "react";
import MatchingVisor from "../MatchingVisor";
import { correctArrayOrdered } from "../../../core/visor/correction_functions";

/* eslint-disable react/prop-types */

export function Matching() {
  return {
    init: function () {
      // eslint-disable-next-line  no-new
      // new sortable();
    },
    getRenderTemplate: function (state, props) {
      return <MatchingVisor state={state} props={props} />;
    },
    checkAnswer(current, correct, state) {
      return correctArrayOrdered(
        current.positionleft,
        current.positionright,
        state.nBoxes,
        state.allowPartialScore
      );
    },
  };
}
/* eslint-enable react/prop-types */
